import React, { useEffect, useRef, useState } from 'react';
import SearchPanel from './SearchPanel';
import LoadingBar from 'react-top-loading-bar'
import { ToastContainer } from 'react-toastify';
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate, useMsal
} from "@azure/msal-react";
import { useHistory } from 'react-router-dom';
import { EventType } from "@azure/msal-browser";


const HeaderDashboard = (props) => {
    const [progress, setProgress] = useState(props.progress)
    const { instance } = useMsal();
    useEffect(() => {
        //initilizeUserInfo(6);
        const callbackId = instance.addEventCallback((message) => {
            if (message.eventType === EventType.LOGIN_SUCCESS) {
                const result = message.payload;
                if (result.idToken) {
                    localStorage.setItem('accessToken', result.idToken);
                    console.log('tokenFull', result.idToken);
                    // initilizeUserInfo(6);
                    //fetchUserData(jwt_decode(instance.tokenCache.storage.browserStorage.windowStorage.accessToken).sub);
                }
            }
        });
        return () => {
            if (callbackId) {
                instance.removeEventCallback(callbackId);
            }
        }

    }, []);
    const history = useHistory();

    useEffect(() => {
        var addBodyDashboardClass = document.getElementsByTagName('body');
        addBodyDashboardClass[0].classList.add('dashboardWrapperCustom');
    });

    return (<>

        <LoadingBar color="#38a668" progress={100} onLoaderFinished={() => setProgress(0)} />
        <ToastContainer />
        <div className="HeaderCard">
            <div className="pagetitle">
                {props.title}
            </div>
            <SearchPanel />
        </div>
        <div className="HeaderTagLine">
            {props.tagLine}
        </div>



    </>)
}

export default HeaderDashboard;